import React, { useEffect, useState } from "react";
import ModalDisplay from "../Partials/ModalDisplay";
import Div from "../../components/common/Div";
import Text from "../../components/common/Text";
import ModalButton from "../../components/common/ModalButton";
import { tenzero } from "../../constants/Constants";
import styling from "./Styling.module.css";
import CheckIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import { Typography } from "@mui/material";
export default function POPIAcceptanceBox(props) {
  let displayValue = "none";
  if (props.display) displayValue = "block";

  const handleClick = () => {
    setLoading(true);
    props.handler2();
    // Assuming handler2 is asynchronous, set loading to false when it's done
    props.handler2().finally(() => setLoading(false));
  };

  const [loading, setLoading] = useState(false);

  return (
    <ModalDisplay display={displayValue}>
      <Div margin={tenzero} style={{ textAlign: "center" }}>
        <CheckIcon style={{ fontSize: "2.5rem", color: "#fbcd02" }} />{" "}
        <Typography
          fontWeight={"bold"}
          color={"rgb(33, 42, 65)"}
          style={{ fontSize: "1.25rem", textAlign: "center" }}
        >
          POPI Acknowledgement
        </Typography>
      </Div>
      <Div margin={tenzero} width={"80%"}>
        <Text color={"rgb(33, 42, 65)"} fontSize={"0.9rem"}>
          Do you acknowledge that MobiTutorZA complies with the POPI Act?
        </Text>
      </Div>
      <Div
        margin={tenzero}
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-in-between",
        }}
      >
        <ModalButton onClick={handleClick} disabled={loading}>
          Confirm
        </ModalButton>
        <ModalButton onClick={props.handler}>Cancel</ModalButton>
      </Div>
    </ModalDisplay>
  );
}
